import React from "react";
import { NavLink } from "react-router-dom";

const HeroSection = () => {
  const currency = [
    { name: "United States", currencyCode: "USD" },
    { name: "United Kingdom", currencyCode: "GBP" },
    { name: "Canada", currencyCode: "CAD" },
    { name: "Australia", currencyCode: "AUD" },
    { name: "Germany", currencyCode: "EUR" },
    { name: "Japan", currencyCode: "JPY" },
    { name: "India", currencyCode: "INR" },
    { name: "Brazil", currencyCode: "BRL" },
    { name: "China", currencyCode: "CNY" },
    { name: "Pakistan", currencyCode: "PKR" },
  ];

  return (
    <div className="hero_section d-flex align-items-center justify-content-center position-relative">
      {/* CONTAINER */}
      <div className="container px-sm-0 px-4">
        <div className="row align-items-center">
          {/* HERO CONTENT SECTION */}
          <div className="col-lg-5 pe-lg-5" data-aos='zoom-in' >
            <div className="hero_content position-relative">
              <div className="coin d-md-block d-none">
                <img src="/image/coin.png" alt="" />
              </div>
              <p className="text-style text-green  fw-light mb-4">
                FAST & HASTLE FREE
              </p>
              <h1>The Most Powerful Money Exchange Service In The World</h1>
              <p className="my-md-5 my-4 text-justify-left">
                It is a long established fact that a reader will be distracted
                by the reale he point of using Lorem Ipsum is that it has a
                more-or-less normal valid equity.
              </p>
              <NavLink to="/" className="btn btn-primary">
                contact us
              </NavLink>
            </div>
          </div>
          {/* HERO IMAGE SECTION */}
          <div className="col-lg-7 mt-lg-1 mt-5 position-relative d-flex  justify-content-md-end justify-content-center pe-lg-5">
            <div className="form_section shadow " >
              <h5 className="text-black fw-bold">Currency Converter</h5>
              <p className="text-black fw-light">I'd Like To Exchange</p>
              <input
                type="text"
                placeholder="$100"
                className="form-control py-sm-4 py-3"
              />
              {/* COUNTRY FROM SECTION */}
              <p htmlFor="first" className="text-black fw-light my-3">
                Country From
              </p>
              <select className="form-select py-sm-4 py-3">
                {currency.map((element, index) => {
                  return (
                    <option value={element.currencyCode} key={index}>
                      {`${element.currencyCode} (${element.name})`}
                    </option>
                  );
                })}
              </select>
              {/* COUNTRY TO SECTION */}
              <p htmlFor="first" className="text-black fw-light my-3">
                Country To
              </p>
              <select className="form-select py-sm-4 py-3">
                {currency.map((element, index) => {
                  return (
                    <option value={element.currencyCode} key={index}>
                      {`${element.currencyCode} (${element.name})`}
                    </option>
                  );
                })}
              </select>
              <NavLink
                className="btn btn-primary mt-4 d-block w-100"
                to={"/converter"}
              >
                Convert now
              </NavLink>
            </div>
            <div className="hero_img position-relative d-md-block d-none  " data-aos='zoom-in' >
              <img src="/image/hero-img.png" alt="boy" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
